import { Component, input } from '@angular/core';
import { SelectionButtonComponent } from '@shared/components/challenges/elements/selection-button/selection-button.component';
import { UnselectionButtonComponent } from '@shared/components/challenges/elements/unselection-button/unselection-button.component';
import { WinCardComponent } from '@shared/components/challenges/elements/win-card/win-card.component';
import { CampaignPhase, SubType } from '@shared/constants';
import { FrequencyChallenge } from '@shared/factory';
import { FrequencyChallengeTenthVariantConfig } from '@shared/models';
import { VariableReplacementPipe } from '@shared/pipes';

import { FrequencyBaseClass } from '../frequency.base.class';

@Component({
  selector: 'b2c-variant10',
  styleUrl: './variant10.component.scss',
  templateUrl: './variant10.component.html',
  imports: [
    WinCardComponent,
    VariableReplacementPipe,
    SelectionButtonComponent,
    UnselectionButtonComponent,
  ],
})
export class Variant10Component extends FrequencyBaseClass {
  /** See {@link Variant6Component.previewSelected}. */
  previewSelected = input<boolean>(false);

  challenge = input.required<FrequencyChallenge>();
  config = input.required<FrequencyChallengeTenthVariantConfig>();

  withShadow = input<boolean>(true);
  isBisCampaign = input<boolean>(false);
  isEventChallenge = input<boolean>(false);
  phase = input<CampaignPhase>(CampaignPhase.CURRENT);

  public readonly SubType: typeof SubType = SubType;
}
